<domain-detail *ngIf="domain" [domain]="domain" [name]="domain?.name" [viewMode]="true" [requestMetadata]="{}"></domain-detail>
